export const WHATSAPP_FREE_MESSAGE_MAX_LENGTH = 800

export function normalizeWhatsappMessage(text: string): string {
  return text.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
}

export function getWhatsappMessageLength(text: string): number {
  return normalizeWhatsappMessage(text).length
}

export function limitWhatsappMessageInput(text: string): string {
  const normalized = normalizeWhatsappMessage(text)
  if (normalized.length <= WHATSAPP_FREE_MESSAGE_MAX_LENGTH) {
    return normalized
  }
  return normalized.slice(0, WHATSAPP_FREE_MESSAGE_MAX_LENGTH)
}
